/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { GradeFrequenceModuleViewModel } from "../types/GradeFrequenceModuleViewModel.ts";
import { gradeFrequenceClassStudentViewModelSchema } from "./gradeFrequenceClassStudentViewModelSchema.ts";
import { gradeFrequenceDisciplineViewModelSchema } from "./gradeFrequenceDisciplineViewModelSchema.ts";

export const gradeFrequenceModuleViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  name: z.string().nullish(),
  classStudents: z
    .array(z.lazy(() => gradeFrequenceClassStudentViewModelSchema))
    .nullish(),
  disciplines: z
    .array(z.lazy(() => gradeFrequenceDisciplineViewModelSchema))
    .nullish(),
}) as unknown as ToZod<GradeFrequenceModuleViewModel>;
